/**
 * ETI-117 — champ e-mail du dialogue « utilisateur » (Gouvernance > Sécurité).
 *
 * L'e-mail est l'IDENTIFIANT DE CONNEXION : en MODIFICATION d'un utilisateur existant il est
 * affiché en lecture seule, avec sa raison ; en CRÉATION il reste saisissable.
 * Le serveur refuse de toute façon un e-mail différent (422) : ce champ évite de proposer
 * une action qui ne peut pas aboutir.
 */
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

export const EXPLICATION_EMAIL_NON_MODIFIABLE =
  "L'adresse e-mail est l'identifiant de connexion : elle ne peut pas être modifiée. " +
  "Pour changer d'adresse, créez un nouveau compte.";

export default function ChampEmailUtilisateur({ value, onChange, modification }) {
  return (
    <div>
      <Label htmlFor="gouv-user-email" className="text-zinc-400">
        Email * <span className="text-zinc-500">(Login)</span>
      </Label>
      <Input
        id="gouv-user-email"
        data-testid="gouv-user-email"
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={modification}
        aria-readonly={modification ? "true" : undefined}
        aria-describedby={modification ? "gouv-user-email-explication" : undefined}
        className={`bg-zinc-800 border-white/10 mt-1${modification ? " opacity-70 cursor-not-allowed" : ""}`}
        placeholder="email@example.com"
      />
      {modification && (
        <p
          id="gouv-user-email-explication"
          data-testid="gouv-user-email-explication"
          className="text-xs mt-1"
          style={{ color: "var(--oh-text-muted)" }}
        >
          {EXPLICATION_EMAIL_NON_MODIFIABLE}
        </p>
      )}
    </div>
  );
}
